export const scrollPageToTop = () => {
  window.scrollTo(0, 0);
};
